(() => {
  const script = document.querySelector('script[data-ss-contact-url]');
  if (!script) return;
  const contactUrl = new URL(script.dataset.ssContactUrl, location.origin);
  if (contactUrl.origin !== location.origin) return;
  const contactForm = () => document.querySelector('input[name="form_type"][value="contact"]')?.form;
  const populate = (subject, body, focus) => {
    const form = contactForm();
    if (!form) return false;
    const message = form.querySelector('[name="contact[body]"]');
    const topic = form.querySelector('select[name="contact[What can we help with]"]');
    if (message && !message.value.trim() && body) message.value = body.slice(0, 8000);
    if (subject && !form.querySelector('[name="contact[Subject]"]')) {
      const field = document.createElement('input');
      field.type = 'hidden'; field.name = 'contact[Subject]'; field.value = subject.slice(0, 250);
      form.append(field);
    }
    if (topic && !topic.value) {
      const value = subject || /SKU:|\/products\//.test(body) ? 'A question about a model' : 'Something else';
      if ([...topic.options].some(option => option.value === value)) {
        topic.value = value; topic.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    if (focus) {
      form.scrollIntoView({block:'center',behavior:'instant'});
      (form.querySelector('[name="contact[name]"]') || message)?.focus({preventScroll:true});
    }
    return true;
  };
  const params = new URLSearchParams(location.search);
  if (params.get('ss_contact') === '1' && populate(params.get('ss_subject') || '', params.get('ss_message') || '', true)) {
    const url = new URL(location.href);
    ['ss_contact','ss_subject','ss_message'].forEach(key => url.searchParams.delete(key));
    history.replaceState(history.state, '', url);
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-ss-native-email') || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    let mail;
    try { mail = new URL(link.href); } catch (_) { return; }
    if (mail.protocol !== 'mailto:') return;
    let recipient;
    try { recipient = decodeURIComponent(mail.pathname).trim().toLowerCase(); } catch (_) { return; }
    if (recipient !== 'info@scaleshowroom.com') return;
    const subject = (mail.searchParams.get('subject') || '').slice(0, 250);
    const body = (mail.searchParams.get('body') || '').slice(0, 8000);
    event.preventDefault();
    if (location.pathname.replace(/\/$/, '') === contactUrl.pathname.replace(/\/$/, '') && populate(subject, body, true)) return;
    const destination = new URL(contactUrl);
    destination.searchParams.set('ss_contact','1');
    if (subject) destination.searchParams.set('ss_subject',subject);
    if (body) destination.searchParams.set('ss_message',body);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id',preview);
    location.assign(destination.href);
  });
})();
